import React, { useEffect } from 'react';
import { ArrowLeft, Award, Users, Shield, Clock, CheckCircle, Target, Globe, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-container">
      <Header />
      
      <section className="service-hero">
        <div className="dark-content-container">
          <Link to="/" className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          
          <div className="service-hero-content">
            <div className="service-badge">
              <Shield className="service-badge-icon" />
              <span>About Cyber-Wiz</span>
            </div>
            
            <h1 className="service-title">
              Cybersecurity Wizardry 
              <span className="service-title-accent"> Delivered by Experts</span>
            </h1>
            
            <p className="service-description">
              Founded by a highly experienced security engineer with extensive industry 
              certifications and proven track record in protecting organizations across 
              diverse sectors. We combine deep technical expertise with strategic 
              business understanding to deliver unparalleled cybersecurity solutions.
            </p>
          </div>
        </div>
      </section>

      <section className="about-detailed-section">
        <div className="dark-content-container">
          <div className="about-grid">
            <div className="about-content">
              <div className="founder-credentials">
                <h3 className="heading-2">Founder & Lead Security Engineer</h3>
                <p className="body-medium">
                  Our founder brings years of hands-on security experience backed by 
                  industry-leading certifications and multi-cloud expertise.
                </p>
                
                <div className="credentials-grid">
                  <div className="credential-category">
                    <Shield className="credential-icon" />
                    <h4 className="heading-3">Security Certifications</h4>
                    <ul className="credential-list">
                      <li>CISSP - Certified Information Systems Security Professional</li>
                      <li>GPEN - GIAC Penetration Tester</li>
                      <li>CCSP - Certified Cloud Security Professional</li>
                      <li>GEVA - GIAC Enterprise Vulnerability Assessor</li>
                      <li>CCSK - Certificate of Cloud Security Knowledge</li>
                    </ul>
                  </div>

                  <div className="credential-category">
                    <Globe className="credential-icon" />
                    <h4 className="heading-3">Cloud Platform Expertise</h4>
                    <ul className="credential-list">
                      <li>AWS Certified Security Specialist</li>
                      <li>Google Cloud Platform (GCP) Certified</li>
                      <li>Microsoft Azure Certified</li>
                      <li>Multi-Cloud Security Architecture</li>
                      <li>Cloud-Native Security Solutions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="about-image">
              <img 
                src="https://images.pexels.com/photos/11035476/pexels-photo-11035476.jpeg?auto=compress&cs=tinysrgb&w=6123&fit=max"
                alt="Cybersecurity Operations"
                className="about-img"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;